import { useNotificationsContext } from "@/app/_providers/NotificationsProvider/NotificationsProvider";

interface CreateNotificationArgs {
  id: string;
  title: string;
  body: string;
  link?: string;
  linkText?: string;
}

const useCreateTeamNotification = () => {
  const { createNotification } = useNotificationsContext();

  const createTeamNotification = async ({
    id,
    title,
    body,
    link,
    linkText,
  }: CreateNotificationArgs) => {
    await createNotification({
      id,
      title,
      body,
      link: link || null,
      linkText: linkText || null,
    });
  };

  return { createTeamNotification };
};

export default useCreateTeamNotification;
